import { NavLink, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useApp } from '../state.js';

const NAV: Array<[string, string, string, string?]> = [
  ['/', '◫', 'Vista mensual'],
  ['/grilla', '▦', 'Balance en grilla'],
  ['/proyeccion', '↗', 'Proyección'],
  ['/movimientos', '≡', 'Movimientos'],
  ['/revisar', '◉', 'Por revisar'],
  ['/conceptos', '◧', 'Conceptos e ingresos', 'PLANIFICACIÓN'],
  ['/fines-de-semana', '▣', 'Fines de semana'],
  ['/por-recuperar', '↩', 'Por recuperar'],
  ['/reglas', '⌘', 'Reglas', 'SISTEMA'],
  ['/sincronizacion', '⟳', 'Sincronización'],
  ['/configuracion', '⚙', 'Configuración'],
];

export const TITLES: Record<string, string> = {
  '/': 'Tu mes, en perspectiva',
  '/grilla': 'El panorama completo',
  '/proyeccion': 'Hasta dónde podemos llegar',
  '/movimientos': 'Cada movimiento, en su lugar',
  '/revisar': 'Unas decisiones y seguimos',
  '/conceptos': 'Lo que ya está previsto',
  '/fines-de-semana': 'Tiempo para disfrutar',
  '/por-recuperar': 'Dinero por recuperar',
  '/reglas': 'Las reglas de casa',
  '/sincronizacion': 'Todo al día',
  '/configuracion': 'A tu manera',
};

export function Layout({ children, tools }: { children: ReactNode; tools?: ReactNode }) {
  const { balance, catalog, authEnabled, logout, auth } = useApp();
  const location = useLocation();
  const base = `/${location.pathname.split('/')[1] ?? ''}`;
  const title = TITLES[base] ?? TITLES['/'];
  const pendingCount = balance ? balance.pending.length + balance.receivables.filter((r) => r.overdue).length + (balance.meters[balance.currentPeriod]?.filter((m) => m.overCents > 0).length ?? 0) : 0;
  return (
    <div className="shell">
      <aside className="sidebar">
        <div className="brand">
          <span>
            bal<span>ance</span>
          </span>
        </div>
        <nav aria-label="Secciones">
          {NAV.map(([to, icon, label, group]) => (
            <div key={to} style={{ display: 'contents' }}>
              {group ? <div className="navlabel">{group}</div> : null}
              <NavLink to={to} end={to === '/'} className={({ isActive }) => (isActive ? 'active' : '')}>
                <span className="icon" aria-hidden="true">
                  {icon}
                </span>
                {label}
                {to === '/revisar' && pendingCount > 0 ? <span className="pillnum">{pendingCount}</span> : null}
              </NavLink>
            </div>
          ))}
        </nav>
        <div className="profile">
          <span className="avatar" aria-hidden="true">
            {(auth?.mode === 'users' && auth.user ? auth.user.displayName : catalog?.household.name ?? 'H').charAt(0).toUpperCase()}
          </span>
          <strong>{auth?.user && auth.mode === 'users' ? auth.user.displayName : catalog?.persons.map((p) => p.name).join(' + ') || catalog?.household.name || 'Hogar'}</strong>
          <div className="muted" style={{ marginTop: 9 }}>
            Un hogar. Un mismo balance.
          </div>
          {authEnabled ? (
            <button type="button" className="ghost" style={{ marginTop: 8, padding: '4px 0' }} onClick={() => void logout()}>
              Salir
            </button>
          ) : (
            <div className="tiny" style={{ marginTop: 8 }}>Sin usuarios ni contraseña · sólo uso local</div>
          )}
        </div>
      </aside>
      <main className="content">
        <header className="pagehead">
          <div>
            <div className="eyebrow">Finanzas del hogar</div>
            <h1>{title}</h1>
          </div>
          <div className="tools">{tools}</div>
        </header>
        {children}
      </main>
    </div>
  );
}

export function Toasts() {
  const { toasts } = useApp();
  return (
    <div className="toasts" aria-live="polite">
      {toasts.map((t) => (
        <div key={t.id} className={`toast ${t.kind === 'error' ? 'error' : ''}`}>
          {t.text}
        </div>
      ))}
    </div>
  );
}
